<template>
    <div>
        <div class="bg-white px-4 rounded-xl content-expiring">
            <div class="flex py-4">
                <div class="mr-0 ml-auto"><img class="h-16" src="@/assets/logo/logo-splus.png" alt=""/></div>
                <div class="ml-2 mr-auto">
                    <div>
                        <div class="text-20 text-gray-1 mt-1">คะแนนปัจจุบัน : </div>

                    </div>
                    <div class="flex">
                        <div class="text-26 text-blue-1 mb-0 mt-auto mr-1">{{FilterNumberFormat(profile.updated_points.points)}}</div>
                        <div class="text-20 text-gray-1 mb-0.5 mt-auto">คะแนน</div>
                    </div>

                </div>
            </div>
            <div class="flex w-full bg-blue-1 rounded-full h-1"></div>
            <div class="py-4">
                <div v-for="(pointItem,index) in pointList"
                    :key="index"
                    class="flex w-full text-20 text-gray-1 py-2"
                    >
                    <div class=" flex justify-between" v-if="checkYear(pointItem)">
                        <div class="ml-0 mr-auto">คะแนนของคุณจะหมดอายุภายในวันที่ {{getTimeEarn(pointItem)}}</div>
                        <div class="ml-auto mr-0 w-20 text-right font-bold text-blue-1">{{FilterNumberFormat(pointItem.points)}} คะแนน</div>
                    </div>
                </div>
                <div v-if="!havePoint" class="flex w-full text-20 text-gray-1 py-2">
                    <div class=" flex justify-between" >
                        <div class="ml-0 mr-auto">คะแนนของคุณจะหมดอายุภายในวันที่  31 ธ.ค.{{getcurrentYear()}}</div>
                        <div class="ml-auto mr-0 w-20 text-right font-bold text-blue-1">0 คะแนน</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-1">
            <img class="m-auto mt-5 h-4" src="../../../assets/logo/logo-bzb-new.png" alt=""/>
        </div>
    </div>

</template>

<script>
import BzbsPoint from '@/core/Point/service/BzbsPoint';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
export default {
    name: "Expiring",
    mixins: [AuthStatusMixin],
    data: function() {
        return {

            havePoint: false,
            pointList: [],

        };
    },
    created: function() {
        this.getList();
    },
    methods: {
        checkYear: function (pointItem) {
            let currentYear = new Date().getFullYear();
            let year = DatetimeHelper.unixTimestampToDate(pointItem.time).getFullYear();
            console.log(year)
            if (currentYear == year){
                this.havePoint = true;
                return true;
            } else {
                return false;
            }

        },
        getcurrentYear: function () {
            let currentYear = new Date().getFullYear();
            return DatetimeHelper.getYearByLocale(currentYear);
        },
        getTimeEarn: function (pointItem) {
            return DatetimeHelper.getDateShortFormat(pointItem.time);
        },
        getList: function () {
            return new Promise((resolve) => {
                BzbsPoint.apiAllExpiring().subscribe({
                    next: (data) => {
                        if (data.expiring_points) {
                            this.pointList = data.expiring_points;
                        }
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                    }
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .content-expiring {
        min-height: calc(100vh - 300px);
    }
</style>
